import { TypeOrderEnum } from '@model/enum/type-order.enum';

export class BilletInputConfigModel {
  id: number;
  desc: string;
  webFeeder: TypeOrderEnum;
  inputsConfig: InputsConfig[];
}

export interface InputsConfig {
  id: number;
  inputName: string;
  desc: string;
  col: number;
  class: string;
  active: boolean;
  showToggle?: boolean;
  subInputs?: SubInput[];
}

export interface SubInput {
  id: number;
  inputName: string;
  desc: string;
  col: number;
  class: string;
}
